import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '../../enums/common'
import { IAddress, IParcoursAddressSlice } from '../../interfaces/Address'
import { setLoadedDone, setLoading } from '../reducers'

const parcoursAddressSlice = createSlice({
  name: 'parcoursAddress',
  initialState: {
    status: STATUS.idle,
    address: null,
  } as IParcoursAddressSlice,
  reducers: {
    addressLoading: setLoading,
    addressLoaded: setLoadedDone,
    addressReceived: (
      state: IParcoursAddressSlice,
      action: PayloadAction<{ address: IAddress | null }>
    ) => {
      if (state.status === STATUS.pending) {
        return {
          ...state,
          address: action.payload.address,
          status: STATUS.loaded,
        }
      }

      return state
    },
    addressFailed: (state: IParcoursAddressSlice) => {
      if (state.status === STATUS.pending) {
        return {
          ...state,
          status: STATUS.failed,
        }
      }

      return state
    },
  },
})

const { actions, reducer } = parcoursAddressSlice
export const parcoursAddressActions = actions

export default reducer
